document.addEventListener('click', function (event) {
  const summary = event.target.closest('.js-filter > summary');
  if (summary) {
    event.preventDefault();
    const details = summary.parentElement;
    if (details) {
      details.open = true;
      details.setAttribute('open', 'open');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-filter').forEach((filter) => {
    filter.open = true;
    filter.setAttribute('open', 'open');
  });
});


document.addEventListener('change', function(e) {
  const checkbox = e.target.closest('.custom-collection-checkbox');
  if (!checkbox) return;

  const url = checkbox.dataset.url;
  if (!url) return;

  fetch(url, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProducts =
        doc.querySelector('#ProductGridContainer') ||
        doc.querySelector('.product-grid-container') ||
        doc.querySelector('.product-grid') ||
        doc.querySelector('#product-grid');

      const currentProducts =
        document.querySelector('#ProductGridContainer') ||
        document.querySelector('.product-grid-container') ||
        document.querySelector('.product-grid') ||
        document.querySelector('#product-grid');

      if (newProducts && currentProducts) {
        currentProducts.innerHTML = newProducts.innerHTML;
      }

      const newCount = doc.querySelector('#ajax-product-count');
      const currentCount = document.querySelector('#ajax-product-count');

      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }

      document.querySelectorAll('.custom-collection-checkbox').forEach(item => {
        item.checked = false;
      });

      checkbox.checked = true;
    })
    .catch(error => {
      console.error('Collection filter error:', error);
    });
});




function setDefaultGrid() {
  const grid = document.getElementById("gf-products");
  if (!grid) return;

  grid.classList.remove("grid-2", "grid-4", "grid-5");

  let view;

  if (window.innerWidth <= 768) {
    view = "grid-2";
  } else {
    view = "grid-4";
  }

  grid.classList.add(view);

  // active button update
  document.querySelectorAll(".view-btn").forEach(b => b.classList.remove("active"));
  const btn = document.querySelector(`.view-btn[data-view="${view}"]`);
  if (btn) btn.classList.add("active");
}

// Load par
document.addEventListener("DOMContentLoaded", setDefaultGrid);

// Resize par bhi
window.addEventListener("resize", setDefaultGrid);



document.addEventListener("click", function (e) {
  const btn = e.target.closest(".view-btn");
  if (!btn) return;

  const view = btn.getAttribute("data-view");
  const grid = document.getElementById("gf-products");
  if (!grid) return;

  grid.classList.remove("grid-2", "grid-4", "grid-5");
  grid.classList.add(view);

  // Save selection
  localStorage.setItem("gridView", view);

  document.querySelectorAll(".view-btn").forEach(b => b.classList.remove("active"));
  btn.classList.add("active");
});


document.addEventListener("DOMContentLoaded", function () {
  const grid = document.getElementById("gf-products");
  if (!grid) return;

  let savedView = localStorage.getItem("gridView");

  if (!savedView) {
    savedView = window.innerWidth <= 768 ? "grid-2" : "grid-4";
  }

  grid.classList.remove("grid-2", "grid-4", "grid-5");
  grid.classList.add(savedView);

  document.querySelectorAll(".view-btn").forEach(b => b.classList.remove("active"));
  const btn = document.querySelector(`.view-btn[data-view="${savedView}"]`);
  if (btn) btn.classList.add("active");
});


document.addEventListener("DOMContentLoaded", function () {

  const select = document.getElementById("perPageSelect");
  if (!select) return;

  const url = new URL(window.location.href);
  const currentLimit = url.searchParams.get("limit");

  if (currentLimit) {
    select.value = currentLimit;
  }

  select.addEventListener("change", function () {
    url.searchParams.set("limit", this.value);
    url.searchParams.delete("page"); // reset page
    window.location.href = url.toString();
  });

});





(function () {

  function getSortFromURL() {
    return new URLSearchParams(window.location.search).get("sort_by");
  }

  function syncDropdown(order) {
    const select = document.querySelector('#SortBy');
    if (!select || !order) return;

    setTimeout(() => {
      if (select.value !== order) {
        select.value = order;
      }
    }, 100);
  }

  function runSortFix() {

    const container = document.querySelector('#gf-products');
    if (!container) return;

    // Use URL sort if selected.
    // Otherwise use new_to_old as the default.
    const urlOrder = getSortFromURL();
    const order = urlOrder || "new_to_old";

    if (order !== "new_to_old" && order !== "old_to_new") {
      return;
    }

    const items = Array.from(
      container.querySelectorAll('.grid__item')
    );

    items.sort((a, b) => {

      const aDate = new Date(
        a.getAttribute('data-pub-date')
      );

      const bDate = new Date(
        b.getAttribute('data-pub-date')
      );

      return order === "new_to_old"
        ? bDate - aDate
        : aDate - bDate;

    });

    items.forEach(el => container.appendChild(el));

    syncDropdown(order);
  }

  function init() {

    let lastURL = location.href;

    setInterval(() => {

      if (location.href !== lastURL) {

        lastURL = location.href;

        setTimeout(() => {
          runSortFix();
        }, 500);

      }

    }, 300);

    // Initial load
    runSortFix();
  }

  document.addEventListener('DOMContentLoaded', init);

})();






document.addEventListener("DOMContentLoaded", function () {

    const grid = document.querySelector(".custom-grid-view");
    if (!grid) return;

    // Apply default active view on page load
    const activeBtn = document.querySelector(".view-btn-blog.active");
    if (activeBtn) {
        const defaultView = activeBtn.dataset.view;
        grid.classList.remove("grid-2", "grid-4", "grid-5");
        grid.classList.add(defaultView);
    }

    // Change view on click
    document.addEventListener("click", function (e) {

        const btn = e.target.closest(".view-btn-blog");
        if (!btn) return;

        const view = btn.dataset.view;

        grid.classList.remove("grid-2", "grid-4", "grid-5");
        grid.classList.add(view);

        document.querySelectorAll(".view-btn-blog").forEach(function(item){
            item.classList.remove("active");
        });

        btn.classList.add("active");

    });

});




const bodycustom = document.body;

  if (bodycustom.classList.contains("events")) {
    bodycustom.classList.remove("article");
  }

// Array of menu selectors
const menus = [
  '#Details-HeaderMenu-4\\ The\\ Latest',
  '#Details-HeaderMenu-1\\ Categories',
  '#Details-HeaderMenu-2\\ Collections'
];

menus.forEach(selector => {
  const details = document.querySelector(selector);
  if (!details) return;

  details.addEventListener("mouseenter", () => {
    details.setAttribute("open", "");
  });

  details.addEventListener("mouseleave", () => {
    details.removeAttribute("open");
  });
});



// document.addEventListener("DOMContentLoaded", function () {
//   const defaultFvalue = "314611728521";
//   const filterGroupId = 745031;

//   const links = document.querySelectorAll('.simple-image-links a');

//   links.forEach(link => {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();

//       const fvalue = this.dataset.fvalue;
//       if (!fvalue) return;

//       if (typeof toggleRadioFilter === "function") {
//         toggleRadioFilter(filterGroupId, fvalue);
//       }
//     });
//   });

//   // ✅ Default filter on page load
//   setTimeout(() => {
//     if (typeof toggleRadioFilter === "function") {
//       toggleRadioFilter(filterGroupId, defaultFvalue);
//     }
//   }, 800);
// });



$(document).ready(function(){
var swiper = new Swiper("#swiper-card", {
    effect: "cards",
    grabCursor: true,
    initialSlide: 2,
    speed: 500,
    loop: true,
    rotate: true,
    mousewheel: {
    invert: false,
  },
});



var readswiper = new Swiper("#readmore-less-sec", {
  slidesPerView: 1,
  spaceBetween: 20,
  centerMode: true,
  centeredSlides: true,
  loop: true,
  slidesPerGroup: 1, // <-- ensures 1 slide per transition
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: "#readmore-less-sec .swiper-button-next",
    prevEl: "#readmore-less-sec .swiper-button-prev",
  },
  pagination: {
    el: "#readmore-less-sec .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {  // Tablet
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroup: 1, // <-- 1 slide at a time
    },
    1024: { // Desktop
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1, // <-- 1 slide at a time
    }
  }
});

// Pause autoplay on hover
var readswiper1 = document.querySelector("#readmore-less-sec");
readswiper1.addEventListener("mouseenter", function() {
  readswiper.autoplay.stop();
});
readswiper.addEventListener("mouseleave", function() {
  readswiper.autoplay.start();
});


// Read More Slider
var rmslider = new Swiper("#customHtmlSlider", {
      centerMode: true,
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: "#customHtmlSlider .swiper-button-next",
        prevEl: "#customHtmlSlider .swiper-button-prev",
      },
      pagination: {
        el: "#customHtmlSlider .swiper-pagination",
        clickable: true,
      },
    });

    // Pause autoplay on hover
    var rmsliderEl = document.querySelector("#customHtmlSlider");
    rmsliderEl.addEventListener("mouseenter", function() { rmslider.autoplay.stop(); });
    rmsliderEl.addEventListener("mouseleave", function() { rmslider.autoplay.start(); });


    // cstm-readmore
    $(".text-more").hide();
    $(".toggle-read").click(function() {
      var $btn = $(this); // current button clicked
      var $text = $btn.siblings(".text-more"); // find the text-more div in the same slide

      if ($btn.text() == "Read More") {
        $btn.text("Read Less");
        $text.slideDown();
      } else {
        $btn.text("Read More");
        $text.slideUp();
      }
    });

// Read More Slider
// var lsslider = new Swiper("#cstmlastslider", {
//   centerMode: true,
//       slidesPerView: 1,
//       spaceBetween: 20,
//       loop: true,
//       autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//       },
//       navigation: {
//         nextEl: "#cstmlastslider .swiper-button-next",
//         prevEl: "#cstmlastslider .swiper-button-prev",
//       },
//       pagination: {
//         el: "#cstmlastslider .swiper-pagination",
//         clickable: true,
//       },
//     });

//     // Pause autoplay on hover
//     var lssliderEl = document.querySelector("#cstmlastslider");
//     lssliderEl.addEventListener("mouseenter", function() { lsslider.autoplay.stop(); });
//     lssliderEl.addEventListener("mouseleave", function() { lsslider.autoplay.start(); });



 });


 document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");
  accordions.forEach(acc => {
    const header = acc.querySelector(".accordion-header");
    header.addEventListener("click", () => {
      // Close all other accordions
      accordions.forEach(a => {
        if(a !== acc) {
          a.classList.remove("active");
          a.querySelector(".accordion-content").style.maxHeight = 0;
        }
      });

      // Toggle current accordion
      acc.classList.toggle("active");
      const content = acc.querySelector(".accordion-content");
      if(acc.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = 0;
      }
    });
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.product-slider', {
      slidesPerView: 1,      // visible products
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        480: { slidesPerView: 1 },
      }
    });
  });



  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.copy-btn').forEach(button => {
      button.addEventListener('click', () => {
        const url = button.getAttribute('data-url');
        navigator.clipboard.writeText(url).then(() => {
          button.innerHTML = '✔️';
          setTimeout(() => {
            button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
<path d="M16.5 9.22766V6.97766C16.5 6.38092 16.2629 5.80863 15.841 5.38667C15.419 4.96471 14.8467 4.72766 14.25 4.72766H6C5.40326 4.72766 4.83097 4.96471 4.40901 5.38667C3.98705 5.80863 3.75 6.38092 3.75 6.97766V15.2277C3.75 15.8244 3.98705 16.3967 4.40901 16.8187C4.83097 17.2406 5.40326 17.4777 6 17.4777H8.25M16.5 9.22766H18C18.5967 9.22766 19.169 9.46471 19.591 9.88667C20.0129 10.3086 20.25 10.8809 20.25 11.4777V18.9777C20.25 19.5744 20.0129 20.1467 19.591 20.5687C19.169 20.9906 18.5967 21.2277 18 21.2277H10.5C9.90326 21.2277 9.33097 20.9906 8.90901 20.5687C8.48705 20.1467 8.25 19.5744 8.25 18.9777V17.4777M16.5 9.22766H10.5C9.90326 9.22766 9.33097 9.46471 8.90901 9.88667C8.48705 10.3086 8.25 10.8809 8.25 11.4777V17.4777" stroke="#103758" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
          }, 1500);
        });
      });
    });
  });




// document.addEventListener("click", function(e) {

//   // check if filter or pagination clicked
//   if (e.target.closest("[onclick*='toggleCheckboxFilter']") ||
//       e.target.closest("[onclick*='removeFilter']") ||
//       e.target.closest("[onclick*='changeSortBy']") ||
//       e.target.closest(".pagination a")) {

//       e.preventDefault(); // stop default behavior

//       // Globo function that actually updates products
//       if (typeof GloboFilters !== 'undefined' && GloboFilters.updateProducts) {
//           GloboFilters.updateProducts();
//       }
//   }

// });


jQuery(document).ready(function ($) {

    // Sirf Review Blog template par chalega
    if (!$('body').hasClass('review-blog')) {
        return;
    }

    // TOC Section
    $('#shopify-section-template--18883512762467__author_toc_YkpWTQ')
        .wrap('<div class="review-left-content"></div>');

    // Remaining Sections
    $(
        '#shopify-section-template--18883512762467__key_takeaways_section_TyHpbw,' +
        '#shopify-section-template--18883512762467__review_content_custom_img_TJAnCM,' +
        '#shopify-section-template--18883512762467__reader_breakdown_UWJN9E,' +
        '#shopify-section-template--18883512762467__review_quote_section_q7n7y4,' +
        '#shopify-section-template--18883512762467__review_section_4pppzg,' +
        '#shopify-section-template--18883512762467__review_content_block_qhekzB'
    ).wrapAll('<div class="bottom-wrapper"></div>');

    $('.review-left-content, .bottom-wrapper')
        .wrapAll('<div class="custom-main-wrapper-blog"></div>');

});



jQuery(document).ready(function ($) {

    if (!$('body').hasClass('product')) return;

    const $button = $('.custom-shop-pay');

    if (!$button.length) return;

    const observer = new IntersectionObserver(function(entries) {

        entries.forEach(function(entry) {

            if (entry.boundingClientRect.bottom < 0) {
                $button.addClass('custom-buy-sticky');
            } else {
                $button.removeClass('custom-buy-sticky');
            }

        });

    });

    observer.observe($button[0]);

});


jQuery(document).ready(function ($) {

    $('#Quantity-Form-template--18589411606627__main, .button-product-wrapper')
        .wrapAll('<div class="custom-button-prod-main"></div>');

});









jQuery(document).ready(function () {

    var toc = jQuery(".toc-links");

    toc.empty();

    jQuery(".bottom-wrapper > .shopify-section").each(function (index) {

        var section = jQuery(this);

        // Khaali section (jaise bina reviews ka external reviews section) TOC mein nahi aayega
        if (!jQuery.trim(section.text())) {
            return; // is section ko skip karo, agle pe jao
        }

        var title = "";

        var heading = section.find("h1, h2, h3, h4, h5, h6").first();

        if (heading.length) {
            title = heading.text().trim();
        } else {
            title = "Section " + (index + 1);
        }

        var id = "toc-section-" + index;

        section.attr("id", id);

        toc.append(
            '<li><a href="#' + id + '">' +
            title +
            '</a></li>'
        );

    });

});

jQuery(document).on("click", ".toc-links a", function (e) {

    e.preventDefault();

    var target = jQuery(jQuery(this).attr("href"));

    if (target.length) {

        jQuery("html, body").animate({

            scrollTop: target.offset().top - 120

        }, 500);

    }

});

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  const drawer = document.querySelector('.drawer');
  const productButtons = document.querySelector('.product-form .product-form__buttons');

  if (!drawer || !productButtons) return;

  const updateButtons = () => {
    if (drawer.classList.contains('active')) {
      productButtons.style.zIndex = '1';
    } else {
      productButtons.style.zIndex = '9999';
    }
  };

  updateButtons();

  const observer = new MutationObserver(updateButtons);

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['class']
  });
});